import React, {useEffect} from "react";
import {useLocation} from "react-router";
import styled from "styled-components";
import {connect} from "react-redux";
import * as actions from "../../../store/actions";
import Comments from "../../../components/Comments/Comments";
import Rating from "../../../components/UI/Rating/Rating";
import {IItem} from "../../../Interfaces";

import Heading from "../../../components/UI/Heading/Heading";
import NutritionsList from "../../../components/Nutritions/NutritionsList";
import {AppState} from "../../../store";

const Wrapper = styled.div`
  margin-top: 50px;
  display: grid;
  width: 90%;

  & > *:nth-of-type(2n-1) {
    background-color: ${({theme}) => theme.colors.background};
  }
  & > *:nth-of-type(2n) {
    background-color: ${({theme}) =>
      theme.colors.background};
  }

  @media (min-width: 768px) {
    width: 60%;
  }
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  border: 2px solid ${({theme}) => theme.colors.main};
  background-color: ${({theme}) => theme.colors.secondary};
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  padding: 0 10%;
  margin: 4px;
  margin-top: 10px;
`;

const Img = styled.img`
  width: 600px;
  height: 600px;
  margin: 20px;
  object-fit: contain;
`;

const NutritionalValues = styled.div`
  & > div {
    list-style: none;
    display: flex;
    justify-content: space-around;
    border: 2px solid ${({theme}) => theme.colors.main};
    background-color: ${({theme}) => theme.colors.secondary};
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    padding: 0 10%;
    margin: 4px;
    margin-top: 10px;
  }
`;

type Props = LinkStateProps & LinkDispatchProps;

const ItemDetails: React.FC<Props> = ({
  items,
  certainItem,
  getProduct, 
}) => {
  const id = useLocation().pathname.split("/")[2];
  let data: any;
  let content = null;

  data = items.filter((item: any) => item.id == id);

  if (data.length == 0 && certainItem == null) {
    getProduct(id);
  } else if (certainItem != null && certainItem.id != id) {
    // getProduct(id);
  }
  if (certainItem != null) {
    data[0] = certainItem;
  }

  if (data[0]) {
    const item = data[0];
    content = (
      <>
        <div>
        <MainWrapper>
          <Img
            src={item.main_photo}
            alt={`${item.name} photo`}
          />
        </MainWrapper>
        <MainWrapper>
          <Heading size="h1" color="black">
            {item.name}
          </Heading>
          <Rating currRating={item.avg_ratio} />
        </MainWrapper>
        </div>
        <div>
          <NutritionalValues>
            <NutritionsList item={item} />
          </NutritionalValues>
        </div>
        <div>
          <Comments id={id} />
        </div>
      </>
    );
  }
  return <Wrapper>{content}</Wrapper>;
};

interface LinkStateProps {
  items: IItem[];
  certainItem: IItem | null;
}

interface LinkDispatchProps {
  getProduct: (id: string) => void;
}

const mapStateToProps = ({local}: AppState) => ({
  items: local.products,
  certainItem: local.details.product,
});

const mapDispatchToProps = {
  getProduct: actions.getProduct,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ItemDetails);
